import axios from "axios";
import { USER_LOGIN_PATH } from "../../Constants/apiPaths";
import { LOGIN_FAILED_MESSAGE } from "../../Constants/messages";
import { syncSocketAuthToken } from "../../socket";
import { forceLogout } from "../auth/session.service";

const ACCESS_TOKEN_KEY = "accessToken";

export const login = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  const response = await axios.post(USER_LOGIN_PATH, {
    email: email.trim(),
    password,
  });

  const responseData = response.data?.responseData;
  const accessToken = responseData?.accessToken;

  if (!accessToken) {
    throw new Error(LOGIN_FAILED_MESSAGE);
  }

  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  syncSocketAuthToken();

  return responseData;
};

export const fetchMe = () => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (!accessToken) {
    return null;
  }

  return axios
    .get("api/v1/user/me")
    .then((response) => {
      return response.data.responseData;
    })
    .catch((error) => {
      throw error;
    });
};

export const logout = () => {
  forceLogout();
};
